// extracted by mini-css-extract-plugin
export var buttons = "_aj-0";
export var buttonsActive = "_aj-h";
export var cancelConfirm = "_aj-1";
export var closeButton = "_aj-2";
export var column = "_aj-3";
export var container = "_aj-4";
export var detailHeader = "_aj-6";
export var detailTitle = "_aj-7";
export var detailsContent = "_aj-5";
export var header = "_aj-8";
export var headerWithClose = "_aj-9";
export var icon = "_aj-a";
export var infoIcon = "_aj-c";
export var informationContainer = "_aj-b";
export var sideDrawer = "_aj-d";
export var sideDrawerOpen = "_aj-e";
export var stickyFooter = "_aj-f";
export var typeOption = "_aj-g";